jQuery('#search').click(function(){
	
	browse_students();
	
});

jQuery( '#consultant, #teacher, #grade, #status, #sortby, #textsearch, #speaks, #expertise, #subjects' ).change(function() {
	
	var this_field = jQuery(this).val();
	
	if( this_field != '' ) {
		
		jQuery(this).parent().addClass('has-value');
		
	}
	
	else {
		
		jQuery(this).parent().removeClass('has-value');
		
	}

	browse_students();

});

jQuery( document ).ready(function() {
	
	if( jQuery('body').hasClass('page-template-template-all-students') ) {
		
		browse_students();
		
	}
	
	if( jQuery('body').hasClass('page-template-template-my-students') ) {
		
		browse_students();
		
	}
	
	if( jQuery('body').hasClass('page-template-template-teachers') ) {
		
		browse_students();
		
	}
	
	if( jQuery('body').hasClass('page-template-template-consultants-list') ) {
		
		browse_students();
		
	}

});

jQuery( 'body' ).on('click', '.has-value', function(e){ 

	e.preventDefault();
    jQuery(this).removeClass('has-value');
	jQuery(this).find('select').val('');	
	browse_students();

	
});

jQuery( "#textsearch" ).keyup(function() {

	browse_students();

});

jQuery( '#consultant' ).change(function(e) {
	
	if( jQuery('body').hasClass('page-template-template-my-students') ) {
	
		e.preventDefault();
		
		var consultant = jQuery(this).val();
		
		var site = document.location.origin;
		
		var redirect = site + '/consultant-dashboard/all-students/?consultant=' + consultant;
		
		window.location.href = redirect;
	
	}
	
});